module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-invoices_total"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-9': !_vm.selectedBracket, 'col-lg-3': _vm.selectedBracket
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerGroups"
    }
  }), _vm._v("\n                    Hvordan er kunderne fordelt på omsætning?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading && _vm.rows.length > 0) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.handleRowClick
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'bracket') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.bracket) + " kr.\n                            ")]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3838996434)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.selectedBracket, 'col-lg-9': _vm.selectedBracket
    }
  }, [(!_vm.selectedBracket) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg et interval for at se en liste over alle kunder i intervallet.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedBracket) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedBracket = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedBracket) ? _c('customer-grouped-single', {
    attrs: {
      "customers": _vm.groupedCustomers[_vm.selectedBracket],
      "name": _vm.selectedBracket
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49678e64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customers/operations/customerRevenueGrouped.vue
// module id = 858
// module chunks = 0